import React, { useState, useEffect  } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useLocation, useNavigate, Link } from "react-router-dom";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import constants from "../../services/constants";
import dateFormat from 'dateformat';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { getSearchApi } from "../../services/routes.services";
const SearchResult=({setKeyword})=>{
    const [inputValue, setInputValue] = useState("");

    const navigate = useNavigate();
    const { state } = useLocation();
    useEffect(() => {
        if (state?.keyWord) {
          setInputValue(state.keyWord);
        }
      }, [state]);
    const smoothScroll = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };
    if(!state){
        return(
            <div className={Style.searchData}>
                <h4>No search keyword</h4>
            </div>
        )
    }
    const { keyWord, result } = state;
    console.log(result)
   
    const searchHandler = async ()=>{
        try{
            const response = await getSearchApi(inputValue);
            navigate('/search', { state: {keyWord: inputValue, result : response.data} })
        }catch(error){
            console.error('error search result', error)
        }
    }
    return(
        <div className={Style.searchData}>
            <Container>
                <Row>
                    <Col>
                        <div className={Style.searchStyle}>
                            <input type="text" placeholder="Search" value={inputValue} onChange={(e) => setInputValue(e.target.value)}  onKeyDown={(e)=>{ if(e.key === 'Enter'){searchHandler();}}} />
         
                            <button type="button" onClick={searchHandler}>Search</button>
                        </div>
                        <Tabs>
                            <TabList  className='searchTab'>
                            <Tab>Events</Tab>
                            <Tab>News</Tab>
                            </TabList>

                            <TabPanel>
                                <Row>
                                    <Col><h4>VIEWING {result.events.length} RESULTS FOUND FOR "{keyWord}"</h4></Col>
                                </Row>
                                <Row>
                                    {result.events.map((value, i) => (
                                        <Col md={4} key={i}>
                                            <div className={Style.mediaList}>
                                                <div className={Style.mediaImg}>
                                                    {value.image !== "null" ?(
                                                    <img src={`${constants.IMAGE_BASE_URL}event/thumb/${encodeURIComponent(value.thumb)}`} className={Style.coverImg} />    
                                                    ):( <img src={require('../../assest/images/no-img.jpg')} className={Style.coverImg} />)}
                                                    <Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll} className={Style.eventTag + ' ' + Button.brownBtn}>{value.title}</Link>
                                                </div>
                                                <div className={Style.mediaDetail}>
                                                    <h6>{dateFormat(value.eventDate, "dd mmmm yyyy ")}</h6>
                                                    <h4><Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll}>{value.title}</Link></h4>
                                                    <Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll}><IoArrowForwardCircleOutline className={Style.mediaLink} /></Link>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                
                                </Row>
                            </TabPanel>
                            <TabPanel>
                                <Row>
                                    <Col><h4>VIEWING {result.news.length} RESULTS FOUND FOR "{keyWord}"</h4></Col>
                                </Row>
                                <Row>
                                    {result.news.map((value, i) => (
                                        <Col md={4} key={i}>
                                            <div className={Style.mediaList}>
                                                <div className={Style.mediaImg}>
                                                    {value.image !== "null" ?(
                                                    <img src={`${constants.IMAGE_BASE_URL}news/${encodeURIComponent(value.thumb)}`} className={Style.coverImg} />    
                                                    ):( <img src={require('../../assest/images/no-img.jpg')} className={Style.coverImg} />)}
                                                    <Link to={`/event-detail/${value.newsSlug}`} onClick={smoothScroll} className={Style.eventTag + ' ' + Button.brownBtn}>{value.title}</Link>
                                                </div>
                                                <div className={Style.mediaDetail}>
                                                    <h6>{dateFormat(value.eventDate, "dd mmmm yyyy ")}</h6>
                                                    <h4><Link to={`/event-detail/${value.newsSlug}`} onClick={smoothScroll}>{value.title}</Link></h4>
                                                    <Link to={`/event-detail/${value.newsSlug}`} onClick={smoothScroll}><IoArrowForwardCircleOutline className={Style.mediaLink} /></Link>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </TabPanel>
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}

export default SearchResult;